(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireba5a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireba5a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aL22a", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("8f30C")).then(()=>parcelRequire('26Y1f'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("5vcI8", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("ezBry")).then(()=>parcelRequire('6g2Ki'));

});

parcelRegister("03THt", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("fR1jP")).then(()=>parcelRequire('jh16R'));

});

var $1b743b019b918db8$exports = {};
$parcel$extendImportMap({
    "8f30C": "slider.419dbe5e.js",
    "ezBry": "lottie.f2087016.js",
    "fR1jP": "mouse.5e99bfba.js"
});

// import * as CookieConsent from "vanilla-cookieconsent";
// window.CookieConsent = CookieConsent;
function $194a19f08914e0aa$export$2e2bcd8739ae039() {
    const burger = document.querySelectorAll('.burger');
    const menu = document.querySelector('.menu');
    const openButton = document.querySelector('.burger-open');
    burger.forEach((burgerButton)=>{
        burgerButton.addEventListener('click', function() {
            itemClick(this.matches(':focus-visible'));
        });
    });
    // close menu after link clicked
    const menuLinks = document.querySelectorAll('.menu a');
    menuLinks.forEach((link)=>{
        link.addEventListener('click', function() {
            itemClick(false);
        });
    });
    menu.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menu.getAttribute('aria-expanded') === 'true') itemClick(true);
    });
    // Only steer focus for keyboard users. A mouse/touch click shouldn't
    // pull focus onto the close/open button during normal use — that's
    // only needed so a keyboard user lands inside (or back on) the menu.
    function itemClick(moveFocus) {
        burger.forEach((burgerElement)=>{
            let isExpanded = burgerElement.getAttribute('aria-expanded') === 'true';
            burgerElement.setAttribute('aria-expanded', !isExpanded);
            burgerElement.classList.toggle('open');
        });
        let isMenuExpanded = menu.getAttribute('aria-expanded') === 'true';
        menu.setAttribute('aria-hidden', isMenuExpanded);
        menu.setAttribute('aria-expanded', !isMenuExpanded);
        menu.toggleAttribute('inert', isMenuExpanded);
        menu.classList.toggle('open');
        if (moveFocus) {
            if (!isMenuExpanded) menu.querySelector('.burger-close')?.focus();
            else openButton?.focus();
        }
    }
}


function $cb2dca281ba91358$export$2e2bcd8739ae039() {
    document.querySelectorAll('.video-container').forEach((container)=>{
        const video = container.querySelector('video');
        const toggle = container.querySelector('.video-overlay');
        if (!video || !toggle) return;
        const sync = ()=>{
            container.classList.toggle('is-playing', !video.paused && !video.ended);
        };
        toggle.addEventListener('click', (e)=>{
            e.preventDefault();
            // Mobile browsers keep :hover "stuck" on the tapped element until
            // something else is focused. Blurring right away avoids the pause
            // icon getting stuck visible after a single tap.
            toggle.blur();
            if (video.paused || video.ended) video.play().catch(()=>{});
            else video.pause();
        });
        // Reflect the video's actual state rather than assuming it from the
        // click alone, so autoplay, buffering, or the browser pausing the
        // video (e.g. when it scrolls out of view) never desync the icon.
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('ended', sync);
        sync();
    });
}


function $89126740c1d07b4a$export$2e2bcd8739ae039() {
    if (document.querySelector('.intro')) document.querySelector('.intro').classList.add('animate');
}


function $006739c44101238a$export$2e2bcd8739ae039() {
    const header = document.querySelector('.header');
    let ticking = false;
    // Function to handle scroll event
    function updateHeader() {
        const scrollY = window.pageYOffset;
        // Calculate the translateY value based on the scroll position
        const translateYValue = Math.max(50 - scrollY, 0); // Start at 50px and reduce by scroll amount, capped at 0px
        header.style.transform = `translateY(${translateYValue}px)`;
        ticking = false;
    }
    function onScroll() {
        // Defer the style write to the next animation frame so it never
        // runs synchronously alongside other scroll listeners that read
        // layout (e.g. lottie-interactivity), which would force a reflow.
        if (!ticking) {
            window.requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }
    // Attach scroll event listener
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
}




window.addEventListener('DOMContentLoaded', ()=>{
    (0, $194a19f08914e0aa$export$2e2bcd8739ae039)();
    (0, $cb2dca281ba91358$export$2e2bcd8739ae039)();
    (0, $006739c44101238a$export$2e2bcd8739ae039)();
    if (document.querySelector('.slider')) (parcelRequire("aL22a")).then(({ default: initSlider })=>initSlider());
    if (document.querySelector('lottie-player')) (parcelRequire("5vcI8")).then(({ default: initLottieAnimations })=>initLottieAnimations());
});

window.addEventListener('load', ()=>{
    (0, $89126740c1d07b4a$export$2e2bcd8739ae039)();
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) (parcelRequire("03THt")).then(({ default: initMouse })=>initMouse());
});

})();
//# sourceMappingURL=main.js.map
